import React, { createContext, useContext } from 'react';
import { Tooltip, TooltipProps } from 'recharts';

export const AnalysisTooltipSuppressedContext = createContext(false);
// Recharts 3 keeps active points independent of the tooltip while an image modal is open.
export const useAnalysisActiveDot = <T extends boolean | { r: number }>(normal: T): T | false =>
  useContext(AnalysisTooltipSuppressedContext) ? false : normal;

// Recharts 3 can retain an active chart tooltip when the note image modal opens.
// Its supported active prop hides that tooltip for the duration of the modal.
// Recharts 3 sorts by name by default; a stable equal comparison keeps series order.
const keepSeriesOrder = () => 0;
const AnalysisTooltip = (props: TooltipProps) => {
  const suppressed = useContext(AnalysisTooltipSuppressedContext);
  return <Tooltip {...props} itemSorter={props.itemSorter ?? keepSeriesOrder} active={suppressed ? false : props.active} />;
};

export default AnalysisTooltip;
